module.exports = __webpack_public_path__ + "static/media/bouquet-xl.f0eed028.svg";